import { useCallback, useEffect, useState } from 'react';
import { getNewUsersCountApi } from '../api/users.api';
import { getCampaignsApi } from '../api/campaigns.api';
import { apiHandler, unwrapData } from '../utils/apiHandler';
import { formatNavBadge } from '../config/adminNav';

/**
 * Fetches live counts for sidebar badges (new users, pending campaigns).
 */
export function useNavBadges() {
  const [badges, setBadges] = useState({});

  const refreshBadges = useCallback(async () => {
    const [newUsersRes, draftRes, scheduledRes] = await Promise.all([
      apiHandler(() => getNewUsersCountApi()),
      apiHandler(() => getCampaignsApi({ status: 'draft', page: 1, limit: 1 })),
      apiHandler(() => getCampaignsApi({ status: 'scheduled', page: 1, limit: 1 })),
    ]);

    const newUsersCount = newUsersRes.success ? unwrapData(newUsersRes)?.count : 0;
    const draftTotal = draftRes.success ? unwrapData(draftRes)?.total : 0;
    const scheduledTotal = scheduledRes.success ? unwrapData(scheduledRes)?.total : 0;
    const pendingCampaigns = (draftTotal || 0) + (scheduledTotal || 0);

    setBadges({
      users: formatNavBadge(newUsersCount),
      campaigns: formatNavBadge(pendingCampaigns),
    });
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      await refreshBadges();
      if (cancelled) return;
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [refreshBadges]);

  return { badges, refreshBadges };
}
